import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import { APP_SERVICE_ID } from '@/config/environment'

const requestService = new RequestService()

export class ServiceRequests {
  getConfiguration () {
    const route = ServerDirections.CONFIGURATION
    const method = 'get'
    function map (data) {
      return data
    }
    return requestService.makePromise(route, method, {}, map)
  }

  getServiceConfiguration () {
    const route = ServerDirections.SERVICE_CONFIGURATION.replace('{serviceId}', APP_SERVICE_ID)
    const method = 'get'
    function map (data) {
      return data
    }
    return requestService.makePromise(route, method, { noAuth: true }, map)
  }

  getPublicFile (fileId) {
    const route = ServerDirections.PUBLIC_FILES.replace('{fileId}', fileId)
    const method = 'get'
    function map (data) {
      return data
    }
    return requestService.makePromise(route, method, { noAuth: true }, map)
  }

  getPublicFileImage (fileId) {
    const route = ServerDirections.PUBLIC_FILES.replace('{fileId}', fileId)
    const method = 'get'

    function map (data, headers) {
      const type = headers.map['content-type']
      const bytes = new Uint8Array(data)
      const binary = bytes.reduce((data, b) => data += String.fromCharCode(b), '') // eslint-disable-line
      return { file:`data:${ type };base64,${ btoa(binary) }` }
    }
    return requestService.makePromise(route, method, { noAuth: true, responseType: 'arraybuffer', disableStatusHandling: { 404: true } }, map)
  }

  getTypePublicFile (fileId) {
    const route = ServerDirections.PUBLIC_FILES.replace('{fileId}', fileId)
    const method = 'head'

    function map (data, headers) {
      return headers.map['content-type'][0]
    }
    return requestService.makePromise(route, method, { noAuth: true }, map)
  }
}
